// eslint-disable-next-line import/no-amd
define([
    'jquery',
    'underscore',
    '../../app/models/MabinsoModel',
    '../../../utils/Globals'
], ($, _, MabinsoModel, Globals) => {
    const UserModel = MabinsoModel.extend({
        backend: true,
        urlRoot: Globals.baseUrl + 'users/user',
        defaults: {
            username: '',
            lastname: '',
            firstname: '',
            email: ''
        },
        validate() {
            if (!_.isUndefined(Globals.actions)) {
                this.isAdmin = !!(Globals.actions.can('user.admin.global') || Globals.actions.can('user.admin.schema'));
                if (this.form != null) {
                    this.form.validationEngine('hideAll');
                    let myreturn;
                    if (this.isAdmin) {
                        if (_.isUndefined(this.get('roles'))) {
                            $('.rolesCheckbox').validationEngine('showPrompt', $._('validation.required.roles.id'), 'error', 'topRight', true);
                            myreturn = 'form.error';
                        }
                        if (Globals.actions.can('user.admin.global')) {
                            if (_.isUndefined(this.get('schemas'))) {
                                $('.schemasCheckbox').validationEngine('showPrompt', $._('validation.required.schemas.id'), 'error', 'topRight', true);
                                myreturn = 'form.error';
                            }
                        }
                    }
                    if (!this.form.validationEngine('validate')) {
                        myreturn = 'form.error';
                    }
                    return myreturn;
                }
            }
        }
    });
    return UserModel;
});



// WEBPACK FOOTER //
// ./src/components/user/models/UserModel.js